import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Seo } from '../components/Seo';
import { Button } from '../components/ui/button';
import { Compass, Home as HomeIcon } from 'lucide-react';

// Real 404 for unknown URLs — set noindex so Google stops flagging these as Soft 404 /
// "Alternate page with proper canonical" (previously the catch-all rendered the homepage at 200).
export default function NotFound() {
  return (
    <Layout>
      <Seo title="Page not found" noindex />
      <section className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
        <div className="mx-auto grid place-items-center h-16 w-16 rounded-2xl bg-accent/12 text-accent mb-5">
          <Compass className="h-8 w-8" />
        </div>
        <h1 className="font-display text-4xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground mt-2">The page you're looking for doesn't exist or may have moved. Let's get you back on track.</p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <Link to="/"><Button className="rounded-xl bg-accent text-accent-foreground hover:bg-accent/90" data-testid="notfound-home"><HomeIcon className="h-4 w-4 mr-1.5" /> Go home</Button></Link>
          <Link to="/flights"><Button variant="outline" className="rounded-xl" data-testid="notfound-flights">Search flights</Button></Link>
          <Link to="/hotels"><Button variant="outline" className="rounded-xl" data-testid="notfound-hotels">Search hotels</Button></Link>
        </div>
      </section>
    </Layout>
  );
}
